import { ChangeEvent, ReactNode, useEffect, useState } from 'react';
import { Box } from '@/components/Box/Box';
import { InputError } from '../InputError/InputError';
import 'react-phone-input-2/lib/high-res.css';
import noop from 'lodash/noop';
import { Input } from '../Input/Input';
import uniqueId from 'lodash/uniqueId';
import { Label, StyledPhoneInput } from '../FormikPhoneInput/styles';

interface ChangeCountryType {
  countryCode: string;
  dialCode: string;
  format: string;
  name: string;
}

interface PhoneInputType {
  name: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  onBlur?: (e: ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  disabled?: boolean;
  error?: string;
  apiError?: string;
  onEnterKeyPress?: () => void;
  hint?: ReactNode;
  touched?: boolean;
}

const DEFAULT_COUNTRY_CODE = 'us';
const DEFAULT_ID = uniqueId();

export const PhoneInput = ({
  name,
  label,
  value,
  onChange,
  onBlur = noop,
  disabled,
  error,
  apiError,
  onEnterKeyPress = noop,
  hint,
}: PhoneInputType) => {
  const [key, setKey] = useState(DEFAULT_ID);

  const hasError = !!error || !!apiError;

  const changePhone = (newPhone: string, country: ChangeCountryType, event: ChangeEvent<HTMLInputElement>) => {
    // Country was changed in dropdown -> reset phone number value
    if (event.type === 'click') {
      onChange(country.dialCode);
    } else {
      onChange(newPhone);
    }
  };

  useEffect(() => {
    if (!value) {
      // Note: "react-phone-input-2" does not update country flag/phone mask on value clear(reset) - force re-render in such case.
      setKey(uniqueId());
    }
  }, [value]);

  return (
    <Box flexDirection='column' rowGap='4px' width='100%' key={key}>
      <Label>{label}</Label>
      <Box flexDirection='column'>
        {disabled ? (
          <Input name={name} value={value} disabled placeholder='Enter Mobile Phone Number' hasErrorComponent={false} />
        ) : (
          <StyledPhoneInput
            inputProps={{ name }}
            country={DEFAULT_COUNTRY_CODE}
            value={value}
            onEnterKeyPress={onEnterKeyPress}
            error={hasError}
            onChange={changePhone}
            onBlur={onBlur}
          />
        )}

        <InputError error={error} apiError={apiError} hint={hint} />
      </Box>
    </Box>
  );
};
